import { Suspense } from 'react';

import { FCC, Skeleton, Stack, Text } from '@eluve/components';

const SkeletonLine: React.FC = () => {
  return <Skeleton className="h-6 w-full bg-white" />;
};

export const AppointmentPageLoader: FCC = ({ children }) => {
  return (
    <Suspense
      fallback={
        <Stack className="container mt-24" gap={2} align="stretch">
          <Text>Loading Appointment...</Text>
          <SkeletonLine />
          <SkeletonLine />
          <SkeletonLine />
        </Stack>
      }
    >
      {children}
    </Suspense>
  );
};
